<template>
  <div id="login">
    <v-container class="l-wrapper pb-0">
      <v-row justify="space-around mt-7">
        <v-sheet width="500" height="520" elevation="3" :tile="false" class="add-edit-wrapper">
          <v-row justify="space-around">
            <v-avatar
              color="#F3F3F2"
              size="62"
            >
              <div class="logo">
                <img :src="require('../../assets/logos/login-logo.gif')" />
              </div>
            </v-avatar>
          </v-row>
          <v-row justify="space-around">
            <h2 class="black--text font-weight-medium">
              {{ error ? 'An error occurred' : 'Logging you in...' }}
            </h2>
          </v-row>
          <v-container>
            <v-row justify="space-around" class="mt-7">
              <h4
                v-if="error"
                class="black--text"
              >
                {{ errorDescription }}
              </h4>
              <v-progress-circular
                v-else-if="loading"
                justify="center"
                indeterminate
                color="#424242"
              ></v-progress-circular>
            </v-row>
            <v-row justify="space-around" class="mt-7">
              <v-btn
                v-if="error"
                class="ma-2"
                outlined
                @click="logout"
                color="indigo"
              >
                Back
              </v-btn>
            </v-row>
          </v-container>
        </v-sheet>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      loading: true
    }
  },
  computed: {
    error () {
      return !!this.$route.query.error
    },
    errorDescription () {
      return this.error ? this.$route.query.error_description : null
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('signOutUserFromApi', this.$router)
        .then(() => {
          this.$auth.logout({
            returnTo: window.location.origin
          })
        })
    }
  },
  watch: {}
}
</script>

<style lang="scss">
  #login {
    // background-image: url('../../assets/img/login/login.png');
    form{
      label {
        color: black;
      }
      .v-input {
        input {
          color: black;
        }
      }
    }
    background-color: #F3F3F2;
    height: 100%;
    background-size: cover;
    padding: 50px 0 0 0;
    .wrapper {
      display: flex;
      flex-direction: column;
      .content-wrapper {
        flex: 1;
      }
      .shapes-wrapper {
        flex: 1;
      }
    }
    .logo {
      background-color: white;
    }
    .login-footer {
      color: $dark-gray-color;
      text-align: center;
      a {
        color: #76a1d8;
        text-decoration: underline;
      }
    }
    .l-wrapper {
      overflow: hidden;
      position: relative;
      min-height: 100%;
      img {
        width: 45px;
        height: 45px;
      }
      .v-avatar {
        position: relative;
        top: -29px;
      }
    }
    .shapes {
      height: 580px;
      .shape-1 {
        position: absolute;
        height: 580px;
        bottom: -100px;
      }
      .shape-2 {
        position: absolute;
        height: 180px;
        bottom: 60px;
      }
    }
  }
</style>
